import { fetchToken } from "../../common/FetchCookie";
import { BASE_URL, COMPANY_JOB_LIST, PUBLIC } from "../../common/URLs";


export const fetchJobListByCompany = async (uuid) => {
    const url = `${BASE_URL}/${PUBLIC}/${COMPANY_JOB_LIST}/${uuid}`; // Proxy path
    try {
      const token = await fetchToken()

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      // console.log("response", response)
      const data = await response.json();
      return data;
    } catch (error) {
      console.log("error", error);
    }
  };
